export default {
  nav: {
    home: 'Utama',
    about: 'Tentang Kami',
    programs: 'Program',
    donate: 'Derma',
    contact: 'Hubungi',
  },
  hero: {
    badge: 'Persatuan Insani Darul Hana Kuching',
    title1: 'Cahaya Harapan',
    title2: 'untuk Komuniti Kita',
    subtitle:
      'Kami membantu golongan kurang bernasib baik di Kuching melalui kebajikan, sumbangan dan latihan kemahiran — membina masa depan yang lebih cerah, satu kehidupan pada satu masa.',
    donate: 'Derma Sekarang',
    programs: 'Lihat Program',
    regNo: 'No. Pendaftaran PPM-003-13-12082021',
  },
  stats: {
    tag: 'Impak Kami',
    title: 'Setiap sumbangan mencipta perubahan sebenar',
    subtitle:
      'Sejak pendaftaran kami pada tahun 2021, kami telah berjalan bersama keluarga dan individu yang memerlukan di seluruh Kuching, Sarawak.',
    value1: '5,000+',
    label1: 'Nyawa Disantuni',
    value2: '120+',
    label2: 'Keluarga Dibantu',
    value3: '350+',
    label3: 'Orang Dilatih',
    value4: '40+',
    label4: 'Sukarelawan Aktif',
  },
  about: {
    tag: 'Siapa Kami',
    title: 'Pertubuhan kebajikan berdaftar yang berkhidmat untuk komuniti',
    p1: 'Persatuan Insani Darul Hana Kuching ialah sebuah pertubuhan kebajikan berdaftar di bawah Pendaftar Pertubuhan Malaysia. Berpangkalan di Petra Jaya, Kuching, Sarawak, kami berdedikasi untuk meringankan beban golongan yang memerlukan dan memperkasakan individu agar berdikari.',
    p2: 'Berpandukan kasih sayang dan tanggungjawab, kami menyalurkan kebaikan kepada tindakan yang bermakna — daripada menyampaikan bantuan asas sehinggalah melengkapkan orang ramai dengan kemahiran yang membuka peluang kehidupan yang lebih baik.',
    mission: 'Misi',
    missionText:
      'Menyediakan bantuan kebajikan, sumbangan dan latihan kemahiran yang meningkatkan kualiti hidup golongan kurang bernasib baik.',
    vision: 'Visi',
    visionText:
      'Membina komuniti yang prihatin dan berdikari di mana tiada sesiapa yang ketinggalan.',
    value1: 'Kasih Sayang',
    value2: 'Integriti',
    value3: 'Pemerkasaan',
    reg: 'Berdaftar di bawah Akta Pertubuhan 1966',
  },
  programs: {
    tag: 'Apa Yang Kami Lakukan',
    title: 'Tiga teras memberi kembali',
    subtitle:
      'Kerja kami tertumpu kepada tiga bidang utama yang bersama-sama mencipta perubahan berkekalan untuk komuniti.',
    learnMore: 'Ketahui lebih lanjut',
    charity: {
      title: 'Bantuan Kebajikan',
      desc: 'Mengagihkan bantuan makanan dan barangan keperluan kepada keluarga kurang berkemampuan, warga emas, ibu tunggal dan anak yatim di seluruh Kuching, Sarawak.',
    },
    donation: {
      title: 'Sumbangan & Infaq',
      desc: 'Mengumpul dan menyalurkan zakat, sedekah dan sumbangan am kepada bantuan bulanan, pemberian musim perayaan dan program bantuan komuniti.',
    },
    training: {
      title: 'Latihan Kemahiran',
      desc: 'Memperkasakan orang ramai dengan kemahiran jahitan, masakan, digital dan keusahawanan untuk membina kehidupan yang mampan.',
    },
  },
  donate: {
    tag: 'Derma',
    title: 'Kemurahan hati anda mengubah kehidupan',
    subtitle:
      'Setiap ringgit membawa makanan kepada keluarga yang lapar, kemahiran kepada pencari kerja, dan harapan kepada mereka yang memerlukan. Anda boleh menyumbang terus melalui pindahan bank.',
    bank: 'Pindahan Bank',
    accountName: 'Nama Akaun',
    accountNameValue: 'Persatuan Insani Darul Hana Kuching',
    accountNo: 'Nombor Akaun',
    accountNoValue: '8881025568741',
    bankName: 'Bank',
    bankNameValue: 'AmBank',
    note: 'Sila e-melkan resit pindahan anda ke contact@insanidarulhanakuching.org supaya kami dapat mengesahkan sumbangan anda.',
    cta: 'Jadi Sukarelawan',
  },
  testimonials: {
    tag: 'Testimoni',
    title: 'Kisah harapan dan penghargaan',
    subtitle: 'Dengarlah daripada mereka yang hidupnya telah disentuh oleh kebaikan para penyumbang dan sukarelawan kami.',
    quote1:
      'Terima kasih kepada program bantuan makanan Insani Darul Hana, keluarga saya tidak pernah kelaparan ketika waktu sukar.',
    name1: 'Siti Aisyah',
    role1: 'Ibu Tunggal, Penerima Bantuan',
    quote2:
      'Latihan jahitan telah mengubah hidup saya. Saya kini mencari rezeki dari rumah dan menyara anak-anak saya.',
    name2: 'Rosnah binti Hassan',
    role2: 'Graduan Latihan Kemahiran',
    quote3:
      'Menjadi sukarelawan di sini mengajar saya kuasa sebenar memberi kembali kepada komuniti.',
    name3: 'Ahmad Firdaus',
    role3: 'Sukarelawan',
  },
  contact: {
    tag: 'Sertai Kami',
    title: 'Hubungi atau hulurkan bantuan',
    subtitle:
      'Ada pertanyaan, ingin menderma, atau mahu menjadi sukarelawan? Kami amat menghargai maklum balas anda.',
    addressLabel: 'Alamat',
    address: 'No. 18, Lorong Astana 3, Jalan Astana, Petra Jaya, 93050 Kuching, Sarawak',
    phoneLabel: 'Telefon',
    phone: '+6012-5478388',
    emailLabel: 'E-mel',
    email: 'contact@insanidarulhanakuching.org',
    formTitle: 'Hantar mesej kepada kami',
    formSubtitle: 'Isikan borang dan pasukan kami akan menghubungi anda tidak lama lagi.',
    name: 'Nama Penuh',
    namePlaceholder: 'Nama anda',
    emailField: 'Alamat E-mel',
    emailPlaceholder: 'anda@contoh.com',
    phoneField: 'Nombor Telefon',
    phonePlaceholder: 'cth. +60 12-345 6789',
    subject: 'Perkara',
    subjectPlaceholder: 'Bagaimana kami boleh membantu?',
    message: 'Mesej',
    messagePlaceholder: 'Tulis mesej anda di sini…',
    submit: 'Hantar Mesej',
    sending: 'Menghantar…',
    success: 'Terima kasih! Mesej anda telah dihantar. Kami akan menghubungi anda tidak lama lagi.',
    error: 'Sesuatu telah berlaku. Sila cuba lagi.',
    volunteerTitle: 'Jadi sukarelawan',
    volunteerSubtitle: 'Sumbangkan masa dan kemahiran anda untuk memberi impak kepada komuniti anda.',
    areaLabel: 'Bidang minat',
    area1: 'Pengagihan bantuan makanan',
    area2: 'Latihan kemahiran',
    area3: 'Pengumpulan dana & acara',
    area4: 'Bantuan am',
    availabilityLabel: 'Ketersediaan',
    availabilityPlaceholder: 'cth. hujung minggu, waktu petang',
    volunteerMessage: 'Ceritakan tentang diri anda',
    volunteerMessagePlaceholder: 'Kongsi kemahiran dan pengalaman anda…',
    volunteerSubmit: 'Daftar sebagai Sukarelawan',
  },
  footer: {
    tagline:
      'Pertubuhan kebajikan berdaftar yang berdedikasi kepada kebajikan, sumbangan dan latihan kemahiran untuk komuniti Kuching, Sarawak.',
    quickLinks: 'Pautan Pantas',
    programs: 'Program Kami',
    contact: 'Hubungi Kami',
    rights: 'Hak cipta terpelihara.',
    regNo: 'No. Pendaftaran PPM-003-13-12082021',
  },
};